import styled from 'styled-components';
import { color } from '../../../../Assets/color';

export const UserRowContainer = styled.div`
    width: 100%;
    height: 40px;
    display: flex;
    align-items: center;
    padding: 3px 0;
    margin-bottom: 10px;
`;

export const UserName = styled.div`
    margin-left: 19px;
    flex: 1;
`;

export const AddedButton = styled.button`
    width: 100px;
    height: 23px;
    border-radius: 100px;
    background-color: #fff;
    border: none;
    font-size: 12px;
    text-transform: uppercase;
    cursor: pointer;
    color: ${color('red')};
    outline: none;
`;

export const AddButton = styled.button`
    width: 100px;
    height: 23px;
    border-radius: 100px;
    background-color: rgba(239, 240, 242, 0.18);
    border: none;
    font-size: 12px;
    text-transform: uppercase;
    color: #fff;
    cursor: pointer;
    outline: none;
`;



// WEBPACK FOOTER //
// ./src/UI/Components/Rows/AddMemberRow/style.js